import styled from "styled-components";

import { StyledGeneralConsultation } from "@pages/Patients/GeneralConsultation/GeneralConsultation.styled";

import {
  alignItemsCenter,
  alpha,
  flexColumn,
  flexSpBetween,
  rem,
} from "@styles/Utilities.styled";


export const StyledCreatePatient = styled(StyledGeneralConsultation)`
  margin-bottom: 2rem;

  .header {
    padding-top: 2rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid ${alpha("var(--clr-black)", 0.1)};

    .back-btn-wrapper {
      ${flexColumn}
      gap: 0.35rem;

      .back-btn {
        ${alignItemsCenter}
        gap: 0.5rem;
        color: var(--clr-primary-400);
        font-size: ${rem(15)};

        svg {
          fill: var(--clr-primary-400);
        }
      }
    }

    h2 {
      font-weight: 500;
      font-size: ${rem(20)};
    }
  }

  .body {
    position: relative;
    display: flex;
    gap: 2rem;
    margin-top: 3rem;

    .stepper {
      position: sticky;
      top: 1.5rem;
      height: fit-content;
    }
  }

  .form {
    fieldset {
      ${flexColumn};
      gap: 1.5rem;
      padding: 1rem 1.5rem 2rem;
      border: 1px solid var(--clr-gray-150);
      border-radius: var(--border-radius-2);
    }

    legend {
      padding-inline: 1rem;
      font-size: ${rem(15)};
    }
  }

  .footer {
    ${flexSpBetween}
    padding-top: 1rem;
    margin-top: 3rem;
    gap: 2rem;
    border-top: 1px solid var(--clr-gray-175);

    .wrapper {
      ${alignItemsCenter}
      gap: 1rem;
    }
  }
`;
